import React from "react";

export const FOUR_OCEAN_LOGO_PATH = "/4ocean.png";

export function formatFourOceanDonationSubline(language = "de") {
  return language === "de" ? "Spende" : "Donation";
}

export default function FourOceanDonationTypeLabel({
  language = "de",
  leading = null,
  titleClassName = "text-gray-800 font-normal",
  subtitleClassName = "text-[11px] font-medium text-gray-700/90",
}) {
  return (
    <div className={`flex items-start gap-2 min-w-0 ${titleClassName}`}>
      {leading != null ? (
        <span className="mt-0.5 shrink-0" aria-hidden>
          {leading}
        </span>
      ) : null}

      <img
        src={FOUR_OCEAN_LOGO_PATH}
        alt="4Ocean"
        className="h-5 w-5 object-contain flex-shrink-0 mt-0.5 rounded-[22%] ring-1 ring-slate-200/70"
        draggable={false}
        onError={(event) => {
          event.currentTarget.style.display = "none";
        }}
      />

      <div className="min-w-0 leading-tight">
        <div className="whitespace-normal break-words">4Ocean</div>
        <div className={`whitespace-normal break-words ${subtitleClassName}`}>
          {formatFourOceanDonationSubline(language)}
        </div>
      </div>
    </div>
  );
}
